import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { message } from "antd";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { constants } from "../../../constants/constants";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { getPermission } from "../../../utils/ApiCalls/Permission";
import { deleteWebpage, getAllWebpage, updateWebpage } from "../../../utils/ApiCalls/WebPages";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import ValidDateUI from "../../../constants/validDateUI";
import Swal from "sweetalert2";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { LOG_ACTIONS } from "../../../utils/Constant/LogConstant";
import SwitchBar from "../../../components/Pages/SwitchBar";

const LOCATION_TABS = [
  { title: "Singapore", value: "SG" },
  { value: "MY", title: "Malaysia" },
  { value: "ID", title: "Indonesia" },
  { value: "IN", title: "India" },
  { value: "CN", title: "China" },
  { value: "TW", title: "Taiwan" },
  { value: "HK", title: "Hong Kong" },
  { value: "PH", title: "Philippines" },
  { value: "AE", title: "UAE" },
  { value: "OTHER", title: "All Others" },
];

const Blogs = () => {
  const [role, setRole] = useState("");
  const [roles, setRoles] = useState([]);
  const [regionalActive, setRegionalActive] = useState("SG");
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Blog List",
      route: "/profile/user-management",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();
  const navigate = useNavigate()

  const locationP = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [locationP.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(locationP.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate, locationP.search]);

  const columns = [
    {
      title: "No",
      width: 2,
      dataIndex: "id",
      key: "position",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Image",
      width: 30,
      dataIndex: "image",
      key: "image",
      render: (image, record) => {
        const src =
          record.image ||
          record.simplified_chinese_image ||
          record.traditional_chinese_image ||
          record.bahasa_image;
        return src ? (
          <img
            src={`${constants.MEDIAURL}/${src}`}
            style={{ width: "100px", height: "80px" }}
          />
        ) : null;
      },
    },
    {
      title: "Title",
      width: 400,
      key: "page_name",
      fixed: "left",
      render: (_, record) =>
        record.page_name ||
        record.simplified_chinese_page_name ||
        record.traditional_chinese_page_name ||
        record.bahasa_page_name ||
        "",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",

      render: (item, record, index) => {


        return (
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              checked={item}
              onChange={(value) => {
                try {

                  handleUpdate(
                    record.id,
                    {
                      is_active: value.target.checked ? 1 : 0,
                      slug: record.slug
                    },
                    record.title
                  );
                } catch (error) {
                  dispatch({
                    type: "SET_LOADING",
                    loading: false,
                  });

                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.message,
                  });
                }
              }}
              className="custom-control-input"
              id={"customSwitch1" + index}
            />
            <label
              className="custom-control-label"
              style={{}}
              htmlFor={"customSwitch1" + index}
            ></label>
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "operation",
      width: 30,
      render: (text, record) => (
        <div className="table_action_btn">
          <div
            onClick={() =>
              navigate("/website/webpages/blog/edit/" + record.slug)
            }
            className="btn"
          >
            <i className="ri-edit-2-line" data-toggle="tooltip" title="Edit"></i>
          </div>
          <DeletePop
            onConfirm={() =>
              handleDelete(record.id, record.title, record.location_id)
            }
          >
            <div>
              {" "}
              <button className="btn delete_btn">
                <i
                  className="ri-delete-bin-line"
                  data-toggle="tooltip"
                  title="Delete"
                ></i>
              </button>
            </div>
          </DeletePop>
        </div>
      ),
    },
  ];
  const handleUpdate = async (id, values, title, location_id) => {
    if (checkPermission(permission, "update_per", "Blog", window?.location?.pathname)) {
      let data = await updateWebpage(id, values);
      if (data.error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: data.error,
        });
      } else {
        addlog(
          "Webpage " +
            (values.is_active !== undefined
              ? values.is_active === 1
                ? LOG_ACTIONS.ACTIVATED
                : LOG_ACTIONS.DEACTIVATED
              : LOG_ACTIONS.UPDATED),
          values.slug,
          { ...values, id, title, location_id },
          userDetails.id
        );
      }
      await getData(page);
    } else {
      message.error("Update permission missing");
    }
  };
  useEffect(() => {
    getData(page);
  }, [page, pageSize, regionalActive]);
  const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Blog", window?.location?.pathname)) {
      await deleteWebpage(id);
      await getData(page);
    } else {
      message.error("Missing Permission for delete");
    }
  };

  const getData = async (value) => {
    let args = { page_type: "blog_item", page: value, limit: pageSize };
    if (regionalActive) args.regionalActive = regionalActive;
    let data = await getAllWebpage(args);
    const per = await getPermission();
    setRoles(per?.data?.map((item) => item.name));
    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
    }
  };
  return (
    <Layout type={"read_per"} module_data={"blog"}>
      <CustomHeaderTitle title={"Blog List"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Blog List"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">Blogs List</h5>
                <div className="two_item">
                  <Link
                    to="/website/webpages/blog/add"
                    className="btn export_v_btn mx-2"
                  >
                    Add Blog
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <SwitchBar
                  tabs={LOCATION_TABS}
                  activeTab={regionalActive}
                  setActiveTab={(val) => { setRegionalActive(val); setPage(1); }}
                />
                <div className="table_holder">
                  {roles?.length > 0 && (
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"NewsLetter"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Blogs;
